module.exports = __webpack_public_path__ + "img/button-start-round-on.bddfb04f.svg";